import PropTypes from 'prop-types';
import { Navigate, Route, Routes, useMatch } from 'react-router-dom';

import BasicHomePage from 'pages/BasicHomePage/BasicHomePage';

import AdminRoutes from './users-routes/Admin';
import StudentRoutes from './users-routes/Student';
import SuperAdminRoutes from './users-routes/SuperAdmin';
import TeacherRoutes from './users-routes/Teacher';
import PublicMaterial from '../pages/PublicMaterial';

function AppRoutes({ user, userType }) {
  const publicMaterial = useMatch('/publicMaterial/:id');
  if (publicMaterial) {
    return (
      <Routes>
        <Route path="/publicMaterial/:id" element={<PublicMaterial />} />
      </Routes>
    );
  }
  if (!user) {
    return (
      <Routes>
        <Route path="/" element={<BasicHomePage />} />
        <Route path="/publicMaterial/:id" element={<PublicMaterial />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    );
  }

  switch (userType) {
    case 'Student':
      return <StudentRoutes user={user} userType={userType} />;

    case 'Teacher':
      return <TeacherRoutes user={user} userType={userType} />;

    case 'Admin':
    case 'NewAdmin':
      return <AdminRoutes user={user} userType={userType} />;

    case 'Superadmin':
      return <SuperAdminRoutes user={user} userType={userType} />;

    default:
      return <div role="alert">Не вдалося визначити підтримувану роль. Зверніться до адміністратора.</div>;
  }
}

AppRoutes.propTypes = { user: PropTypes.object, userType: PropTypes.string };

export default AppRoutes;
